const projects_data = [
  {
  title: "Multilingual Speech Recognition",
  description: "Built a hybrid multilingual speech recognition pipeline integrating Whisper and AI4Bharat IndicConformer to support transcription across Indian languages.",
  tech: ["Python", "Whisper", "PyTorch", "Transformers"],
  highlights: [
    "Supports 22+ Indian languages",
    "Automatic language routing",
    "Hybrid Whisper + IndicConformer pipeline",
    "End-to-end speech transcription"
  ],
  github: "https://github.com/shobha-garg/Multilingual-Speech-Recognition-System",
  category: "Artificial Intelligence",
  icon: "mdi:microphone-message",
  gradient: "from-violet-500 to-fuchsia-500"
},

{
  title: "Multilingual Sentiment Analysis",
  description: "Fine-tuned Google's Gemma-3 language model using LoRA to perform multilingual sentiment classification across multiple languages.",
  tech: ["Python", "Gemma-3", "Transformers", "LoRA", "PyTorch"],
  highlights: [
    "Fine-tuned Gemma-3 using LoRA",
    "Parameter-efficient training",
    "Multilingual sentiment classification",
    "Built using Hugging Face ecosystem"
  ],
  github: "https://github.com/shobha-garg/Multilingual-Sentiment-Analysis-using-Gemma-3",
  category: "Generative AI",
  icon: "mdi:robot-happy",
  gradient: "from-pink-500 to-rose-500"
},

{
  title: "Environmental Sound Classification",
  description: "Developed an end-to-end deep learning application for classifying urban environmental sounds using MFCC feature extraction and CNN-based audio classification.",
  tech: ["Python", "TensorFlow", "Librosa", "Flask", "HTML", "CSS"],
  highlights: [
    "CNN-based environmental sound classifier",
    "MFCC feature extraction pipeline",
    "Interactive web interface for predictions",
    "Achieved ~70% classification accuracy"
  ],
  github: "https://github.com/shobha-garg/Environmental-Sound-Classification-.git",
  category: "Artificial Intelligence",
  icon: "mdi:waveform",
  gradient: "from-cyan-500 to-blue-500"
},

{
  title: "Image Super Resolution",
  description: "Implemented an RRDB-based deep learning model for reconstructing high-resolution images from low-resolution inputs using modern super-resolution techniques.",
  tech: ["Python", "PyTorch", "OpenCV", "RRDB"],
  highlights: [
    "RRDB architecture implementation",
    "Image enhancement pipeline",
    "Deep learning-based reconstruction",
    "Supports high-quality image restoration"
  ],
  github: "https://github.com/shobha-garg/Image-Super-Resolution-using-RRDB-Networks",
  category: "Computer Vision",
  icon: "mdi:image-filter-hdr",
  gradient: "from-rose-500 to-red-700"
},


  {
    title: "Library Management System",
    description: "Engineered a full-stack system for e-book issuance and management with optimized query handling and secure authentication.",
    tech: ["Vue.js", "Flask", "SQL", "HTML", "CSS"],
    highlights: [
      "Full-stack e-book management system",
      "30% improvement in book retrieval efficiency",
      "Dynamic access control implementation",
      "Secure authentication with Flask"
    ],
    github: "https://github.com/shobha-garg/Library-Management-System",
    category: "Web Development",
    icon: "mdi:library",
    gradient: "from-emerald-500 to-teal-500"
  },
  {
    title: "Taxi Fare Guru",
    description: "Built a predictive ML model achieving 94% accuracy for taxi fare prediction using EDA, data cleaning, and feature tuning.",
    tech: ["Python", "Scikit-learn", "XGBoost"],
    highlights: [
      "94% prediction accuracy",
      "Comprehensive EDA and data cleaning",
      "Feature engineering and tuning",
      "Real-world application optimization"
    ],
    github: "https://github.com/shobha-garg/Taxi-Fare-Predictor",
    category: "Machine Learning",
    icon: "mdi:car",
    gradient: "from-yellow-500 to-amber-500"
  },
  {
    title: "Current Affairs Quiz Web App",
    description: "Built an interactive current affairs quiz platform improving engagement for 100+ users with secure backend APIs and responsive UI.",
    tech: ["HTML", "CSS", "JavaScript", "Flask", "SQLAlchemy"],
    highlights: [
      "Interactive quiz platform with 100+ active users",
      "Secure backend APIs with Flask and SQLAlchemy",
      "Real-time score tracking system",
      "Responsive UI with intuitive navigation"
    ],
    github: "https://github.com/shobha-garg/Current-Affairs-Quiz",
    category: "Web Development",
    icon: "mdi:quiz",
    gradient: "from-blue-500 to-cyan-500"
  },
  {
    title: "Online Grocery Store",
    description: "Developed a responsive multi-user web app to manage 100+ grocery items with efficient inventory management.",
    tech: ["Flask", "HTML", "Bootstrap", "CSS"],
    highlights: [
      "Multi-user web application",
      "100+ grocery items management",
      "Dynamic category system",
      "Admin inventory monitoring"
    ],
    github: "https://github.com/shobha-garg/Online-Grocery-Store",
    category: "Web Development",
    icon: "mdi:shopping",
    gradient: "from-green-500 to-lime-500"
  },
  {
  title: "Interactive JavaScript Puzzles",
  description:
  "Developed an interactive browser-based jigsaw puzzle game featuring drag-and-drop gameplay, responsive design, and dynamic puzzle generation.",
  tech: ["HTML", "CSS", "JavaScript"],
  highlights: [
    "Interactive drag-and-drop gameplay",
    "Responsive HTML/CSS interface",
    "JavaScript-based puzzle logic",
    "Smooth and intuitive user experience"
  ],
  github: "https://github.com/shobha-garg/Jigsaw-Puzzle.git",
  category: "Miscellaneous",
  icon: "mdi:puzzle", 
  gradient: "from-indigo-500 to-violet-500"
},

{
  title: "Responsive Web Templates",
  description:
  "Designed responsive HTML and CSS templates showcasing clean layouts, modern styling, and reusable frontend components.",
  tech: ["HTML", "CSS", "JavaScript"],
  highlights: [
    "Responsive page layouts",
    "Modern HTML & CSS design",
    "Reusable frontend components",
    "Lightweight and beginner-friendly"
  ],
  github: "https://github.com/shobha-garg/Templates", 
  category: "Miscellaneous",
  icon: "mdi:web-box", 
  gradient: "from-[#ff4e11] to-[#2A0200]"
}
];

export default projects_data;
